// extracted by mini-css-extract-plugin
module.exports = {"container":"OffersList_container__RwkMc","headerColumn":"OffersList_headerColumn__nHNuD","linkColumn":"OffersList_linkColumn__j6U7J"};